<!-- Popup succes centree -->
@if (successMessage) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
  >
    <div
      class="pointer-events-auto bg-white dark:bg-slate-800 rounded-2xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 border border-green-200 dark:border-green-800 animate-[fadeInScale_0.3s_ease-out]"
    >
      <div
        class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-4xl"
      >
        ✅
      </div>
      <p class="text-lg font-semibold text-gray-800 dark:text-gray-100 text-center">
        {{ successMessage }}
      </p>
    </div>
  </div>
}

<div class="max-w-5xl mx-auto p-4 md:p-6">
  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-gray-100">
      ✍️ Saisie des ventes
    </h1>
    <p class="text-gray-600 dark:text-gray-400 mt-1">Enregistrez les ventes de votre événement</p>
  </div>

  <!-- ═══ Stepper amélioré (vert si complété) ═══ -->
  <div class="mb-8">
    <div class="flex items-center justify-between">
      <!-- Step 1 -->
      <div
        class="flex items-center"
        [ngClass]="currentStepIndex >= 1 ? 'text-purple-600' : 'text-gray-400'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all"
          [ngClass]="{
            'bg-green-500 text-white': currentStepIndex > 1,
            'bg-purple-600 text-white': currentStepIndex === 1,
            'bg-gray-200 dark:bg-slate-700 text-gray-500 dark:text-gray-400': currentStepIndex < 1,
          }"
        >
          @if (currentStepIndex > 1) {
            <span>✓</span>
          }
          @if (currentStepIndex <= 1) {
            <span>1</span>
          }
        </div>
        <span class="ml-2 text-sm font-medium hidden sm:inline">Événement</span>
      </div>
      <div
        class="flex-1 h-1 mx-2 md:mx-4 rounded"
        [ngClass]="currentStepIndex > 1 ? 'bg-green-500' : 'bg-gray-200 dark:bg-slate-700'"
      ></div>

      <!-- Step 2 -->
      <div
        class="flex items-center"
        [ngClass]="currentStepIndex >= 2 ? 'text-purple-600' : 'text-gray-400'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all"
          [ngClass]="{
            'bg-green-500 text-white': currentStepIndex > 2,
            'bg-purple-600 text-white': currentStepIndex === 2,
            'bg-gray-200 dark:bg-slate-700 text-gray-500 dark:text-gray-400': currentStepIndex < 2,
          }"
        >
          @if (currentStepIndex > 2) {
            <span>✓</span>
          }
          @if (currentStepIndex <= 2) {
            <span>2</span>
          }
        </div>
        <span class="ml-2 text-sm font-medium hidden sm:inline">Produits</span>
      </div>
      <div
        class="flex-1 h-1 mx-2 md:mx-4 rounded"
        [ngClass]="currentStepIndex > 2 ? 'bg-green-500' : 'bg-gray-200 dark:bg-slate-700'"
      ></div>

      <!-- Step 3 -->
      <div
        class="flex items-center"
        [ngClass]="currentStepIndex >= 3 ? 'text-purple-600' : 'text-gray-400'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all"
          [ngClass]="{
            'bg-green-500 text-white': currentStepIndex > 3,
            'bg-purple-600 text-white': currentStepIndex === 3,
            'bg-gray-200 dark:bg-slate-700 text-gray-500 dark:text-gray-400': currentStepIndex < 3,
          }"
        >
          @if (currentStepIndex > 3) {
            <span>✓</span>
          }
          @if (currentStepIndex <= 3) {
            <span>3</span>
          }
        </div>
        <span class="ml-2 text-sm font-medium hidden sm:inline">Contexte</span>
      </div>
      <div
        class="flex-1 h-1 mx-2 md:mx-4 rounded"
        [ngClass]="currentStepIndex > 3 ? 'bg-green-500' : 'bg-gray-200 dark:bg-slate-700'"
      ></div>

      <!-- Step 4 -->
      <div
        class="flex items-center"
        [ngClass]="currentStepIndex >= 4 ? 'text-purple-600' : 'text-gray-400'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all"
          [ngClass]="{
            'bg-green-500 text-white': currentStepIndex > 4,
            'bg-purple-600 text-white': currentStepIndex === 4,
            'bg-gray-200 dark:bg-slate-700 text-gray-500 dark:text-gray-400': currentStepIndex < 4,
          }"
        >
          4
        </div>
        <span class="ml-2 text-sm font-medium hidden sm:inline">Résumé</span>
      </div>
    </div>
  </div>

  <!-- Error -->
  @if (error) {
    <div
      class="bg-red-50 dark:bg-red-900/20 border border-red-300 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg mb-4 flex items-center gap-2"
    >
      <span>❌</span>
      <span>{{ error }}</span>
    </div>
  }

  <!-- ═══════════════════════════════════════════ -->
  <!-- ÉTAPE 1: Sélection événement               -->
  <!-- ═══════════════════════════════════════════ -->
  @if (step === "select-event") {
    <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6 md:p-8">
      <h2 class="text-xl font-bold mb-2">📅 Sélectionnez l'événement</h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
        Choisissez l'événement dont vous souhaitez saisir les ventes
      </p>
      @if (loading) {
        <div class="text-center py-12">
          <div
            class="w-8 h-8 border-4 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-3"
          ></div>
          <p class="text-gray-500 dark:text-gray-400">Chargement des événements...</p>
        </div>
      }
      @if (!loading && pendingEvents.length === 0) {
        <div class="text-center py-12">
          <span class="text-5xl mb-4 block">🎉</span>
          <p class="text-gray-600 dark:text-gray-400 font-medium">
            Aucun événement en attente de saisie
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Tous vos événements sont à jour !
          </p>
          <button
            (click)="cancel()"
            class="mt-4 px-6 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            Retour au tableau de bord
          </button>
        </div>
      }
      @if (!loading && pendingEvents.length > 0) {
        <div class="space-y-3">
          @for (event of pendingEvents; track event) {
            <div
              (click)="selectEvent(event)"
              class="p-4 border-2 rounded-xl cursor-pointer transition-all hover:shadow-md dark:shadow-slate-900/50"
              [ngClass]="{
                'border-purple-500 bg-purple-50 dark:bg-purple-900/20 shadow-md dark:shadow-slate-900/50':
                  selectedEvent?._id === event._id,
                'border-gray-200 dark:border-slate-700 hover:border-purple-300':
                  selectedEvent?._id !== event._id,
              }"
            >
              <div class="flex justify-between items-center">
                <div class="flex items-center gap-3">
                  <span class="text-2xl">
                    {{
                      event.eventType === "festival"
                        ? "🎪"
                        : event.eventType === "market"
                          ? "🏪"
                          : "📍"
                    }}
                  </span>
                  <div>
                    <h3 class="font-bold text-gray-900 dark:text-white">{{ event.name }}</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400">
                      {{ event.eventDate | date: "fullDate" : "" : "fr" }}
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                      {{
                        event.location?.city ||
                          event.location?.address ||
                          event.location ||
                          ""
                      }}
                      · {{ event.eventType }}
                    </p>
                  </div>
                </div>
                @if (selectedEvent?._id === event._id) {
                  <div
                    class="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center"
                  >
                    <svg
                      class="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="3"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <div class="mt-8 flex justify-between">
        <button
          (click)="cancel()"
          class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 text-sm font-medium"
        >
          Annuler
        </button>
        <button
          (click)="proceedToSalesEntry()"
          [disabled]="!selectedEvent || loading"
          class="px-6 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed font-medium text-sm transition"
        >
          Continuer →
        </button>
      </div>
    </div>
  }

  <!-- ═══════════════════════════════════════════ -->
  <!-- ÉTAPE 2: Saisie produits (aligné avec fixed) -->
  <!-- ═══════════════════════════════════════════ -->
  @if (step === "enter-sales") {
    <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6 md:p-8">
      <h2 class="text-xl font-bold mb-1">📦 Saisie des quantités</h2>
      @if (selectedEvent) {
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-1">
          {{ selectedEvent.name }} —
          {{ selectedEvent.eventDate | date: "fullDate" : "" : "fr" }}
        </p>
      }
      <p class="text-xs text-gray-400 mb-4">
        💡 Utilisez les actions rapides pour saisir plus vite
      </p>
      <!-- Tableau produits (même structure que fixed) -->
      <div class="max-h-[500px] overflow-y-auto border rounded-lg">
        <table class="w-full">
          <thead class="bg-gray-50 dark:bg-slate-900 sticky top-0 z-10">
            <tr>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Produit
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Coût
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Vente
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Reco IA
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Préparé
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Vendu
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Gaspillé
              </th>
              <th
                class="px-3 py-2.5 text-center text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Rupture
              </th>
              <th
                class="px-3 py-2.5 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-slate-700">
            @for (product of productSales; track product) {
              <tr class="hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900">
                <td class="px-3 py-2.5 font-medium text-sm text-gray-900 dark:text-white">
                  {{ product.productName }}
                </td>
                @let prices = getProductPrices(product.productId);
                <td class="px-3 py-2.5 text-xs text-orange-600">
                  @if (prices.purchasePrice) {
                    {{ prices.purchasePrice | number: "1.2-2" }} €
                  } @else {
                    <span class="text-gray-300">—</span>
                  }
                </td>
                <td class="px-3 py-2.5 text-xs text-green-600 dark:text-green-400 font-medium">
                  @if (prices.sellPrice) {
                    {{ prices.sellPrice | number: "1.2-2" }} €
                  } @else {
                    <span class="text-gray-300">—</span>
                  }
                </td>
                <td class="px-3 py-2.5 text-sm">
                  @if (
                    product.recommended !== null &&
                    product.recommended !== undefined
                  ) {
                    <span class="text-purple-600 font-semibold">
                      {{ product.recommended }}
                    </span>
                  }
                  @if (
                    product.recommended === null ||
                    product.recommended === undefined
                  ) {
                    <span class="text-gray-400">—</span>
                  }
                </td>
                <td class="px-3 py-2.5">
                  <input
                    type="number"
                    [(ngModel)]="product.prepared"
                    (ngModelChange)="onPreparedOrSoldChange(product)"
                    min="0"
                    class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-1 focus:ring-purple-500"
                  />
                </td>
                <td class="px-3 py-2.5">
                  <div class="flex flex-col">
                    <input
                      type="number"
                      [(ngModel)]="product.sold"
                      (ngModelChange)="onPreparedOrSoldChange(product)"
                      min="0"
                      [max]="product.prepared"
                      placeholder="—"
                      [class.border-red-500]="
                        product.sold != null && product.sold > product.prepared
                      "
                      class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-1 focus:ring-purple-500"
                    />
                    @if (
                      product.sold != null && product.sold > product.prepared
                    ) {
                      <span class="text-xs text-red-600 dark:text-red-400 mt-0.5">
                        Max: {{ product.prepared }}
                      </span>
                    }
                  </div>
                </td>
                <td class="px-3 py-2.5">
                  <input
                    type="number"
                    [(ngModel)]="product.wasted"
                    min="0"
                    placeholder="—"
                    class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded bg-gray-50 dark:bg-slate-900"
                  />
                </td>
                <td class="px-3 py-2.5 text-center">
                  <input
                    type="checkbox"
                    [(ngModel)]="product.hasRupture"
                    class="w-4 h-4 accent-orange-600"
                  />
                </td>
                <!-- Actions rapides (identique au fixed) -->
                <td class="px-3 py-2.5">
                  <div class="flex flex-wrap gap-1">
                    <button
                      type="button"
                      (click)="setSoldToPrepared(product)"
                      [disabled]="product.prepared === 0"
                      class="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
                      title="Marquer comme tout vendu"
                    >
                      Tout vendu
                    </button>
                    <button
                      type="button"
                      (click)="setExhausted(product)"
                      [disabled]="product.prepared === 0"
                      class="px-2 py-1 text-xs bg-orange-600 text-white rounded hover:bg-orange-700 disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
                      title="Épuisé avec rupture"
                    >
                      Épuisé
                    </button>
                    <div class="flex gap-0.5">
                      <button
                        type="button"
                        (click)="setRemaining(product, 10)"
                        [disabled]="product.prepared === 0"
                        class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                        title="Il reste 10% (90% vendu)"
                      >
                        -10%
                      </button>
                      <button
                        type="button"
                        (click)="setRemaining(product, 20)"
                        [disabled]="product.prepared === 0"
                        class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                        title="Il reste 20% (80% vendu)"
                      >
                        -20%
                      </button>
                      <button
                        type="button"
                        (click)="setRemaining(product, 30)"
                        [disabled]="product.prepared === 0"
                        class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                        title="Il reste 30% (70% vendu)"
                      >
                        -30%
                      </button>
                      <button
                        type="button"
                        (click)="setRemaining(product, 50)"
                        [disabled]="product.prepared === 0"
                        class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                        title="Il reste 50% (50% vendu)"
                      >
                        -50%
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="mt-6 flex justify-between">
        <button
          (click)="goBack()"
          class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 text-sm font-medium"
        >
          ← Retour
        </button>
        <div class="flex gap-3">
          <button
            (click)="saveDraft()"
            [disabled]="loading"
            class="px-5 py-2.5 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-50 dark:bg-purple-900/20 disabled:opacity-50 text-sm font-medium"
          >
            💾 Brouillon
          </button>
          <button
            (click)="proceedToContext()"
            class="px-6 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium text-sm transition"
          >
            Continuer →
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ═══════════════════════════════════════════ -->
  <!-- ÉTAPE 3: Contexte (identique au fixed + durée) -->
  <!-- ═══════════════════════════════════════════ -->
  @if (step === "context") {
    <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6 md:p-8">
      <h2 class="text-xl font-bold mb-2">🌤️ Informations contextuelles</h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
        Ces informations aident l'IA à mieux comprendre les écarts
      </p>
      <div class="space-y-6">
        <!-- Context flags (identique au fixed) -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3"
            >Facteurs exceptionnels</label
          >
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-orange-400]="contextFlags.ruptureStock"
              [class.bg-orange-50]="contextFlags.ruptureStock"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.ruptureStock"
                class="w-5 h-5 accent-orange-600"
              />
              <div>
                <span class="font-medium text-sm">📦 Rupture de stock</span>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Manque de marchandise pendant l'événement
                </p>
              </div>
            </label>
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-blue-400]="contextFlags.unusualAffluence"
              [class.bg-blue-50]="contextFlags.unusualAffluence"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.unusualAffluence"
                class="w-5 h-5 accent-blue-600"
              />
              <div>
                <span class="font-medium text-sm"
                  >👥 Affluence inhabituelle</span
                >
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Plus ou moins de monde que prévu
                </p>
              </div>
            </label>
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-yellow-400]="contextFlags.weatherImpact"
              [class.bg-yellow-50]="contextFlags.weatherImpact"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.weatherImpact"
                class="w-5 h-5 accent-yellow-600"
              />
              <div>
                <span class="font-medium text-sm">🌧️ Météo impactante</span>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Pluie, chaleur extrême, vent...
                </p>
              </div>
            </label>
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-purple-400]="contextFlags.localEvent"
              [class.bg-purple-50]="contextFlags.localEvent"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.localEvent"
                class="w-5 h-5 accent-purple-600"
              />
              <div>
                <span class="font-medium text-sm">🎉 Événement local</span>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Match, concert, marché spécial...
                </p>
              </div>
            </label>
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-red-400]="contextFlags.technicalIssue"
              [class.bg-red-50]="contextFlags.technicalIssue"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.technicalIssue"
                class="w-5 h-5 accent-red-600"
              />
              <div>
                <span class="font-medium text-sm">🔧 Problème technique</span>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Panne, matériel défaillant...
                </p>
              </div>
            </label>
            <label
              class="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-gray-400]="contextFlags.differentLocation"
              [class.bg-gray-100]="contextFlags.differentLocation"
            >
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.differentLocation"
                class="w-5 h-5"
              />
              <div>
                <span class="font-medium text-sm"
                  >📍 Emplacement différent</span
                >
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Changement de spot sur le lieu
                </p>
              </div>
            </label>
          </div>
        </div>
        <!-- Durée réelle (spécifique itinérant) -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
            >⏱️ Durée réelle (heures)</label
          >
          <input
            type="number"
            [(ngModel)]="actualDuration"
            min="0"
            step="0.5"
            placeholder="Ex: 4.5"
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <!-- Affluence (identique au fixed) -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
            >👥 Affluence réelle</label
          >
          <select
            [(ngModel)]="actualAttendance"
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded-lg"
          >
            <option value="">Non spécifié</option>
            <option value="low">Faible</option>
            <option value="medium">Moyen</option>
            <option value="high">Élevé</option>
          </select>
        </div>
        <!-- Météo (identique au fixed) -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
            >🌤️ Météo réelle</label
          >
          <select
            [(ngModel)]="actualWeather"
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded-lg"
          >
            <option value="">Non spécifié</option>
            <option value="sunny">☀️ Ensoleillé</option>
            <option value="cloudy">☁️ Nuageux</option>
            <option value="rainy">🌧️ Pluvieux</option>
            <option value="stormy">⛈️ Orageux</option>
            <option value="windy">💨 Venteux</option>
            <option value="cold">❄️ Froid</option>
          </select>
        </div>
        <!-- Notes -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2"
            >📝 Notes (optionnel)</label
          >
          <textarea
            [(ngModel)]="notes"
            rows="3"
            placeholder="Ajoutez des notes sur cet événement..."
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          ></textarea>
        </div>
      </div>
      <div class="mt-8 flex justify-between">
        <button
          (click)="goBack()"
          class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 text-sm font-medium"
        >
          ← Retour
        </button>
        <button
          (click)="proceedToSummary()"
          class="px-6 py-2.5 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium text-sm transition"
        >
          Voir le résumé →
        </button>
      </div>
    </div>
  }

  <!-- ═══════════════════════════════════════════════════ -->
  <!-- ÉTAPE 4: Résumé + Score précision + Feedback IA    -->
  <!-- ═══════════════════════════════════════════════════ -->
  @if (step === "summary") {
    <div class="space-y-6">
      <!-- Info événement -->
      @if (selectedEvent) {
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6">
          <h2 class="text-xl font-bold mb-4">📋 Résumé et validation</h2>
          <div class="flex items-center gap-3 p-4 bg-gray-50 dark:bg-slate-900 rounded-lg">
            <span class="text-3xl">
              {{
                selectedEvent.eventType === "festival"
                  ? "🎪"
                  : selectedEvent.eventType === "market"
                    ? "🏪"
                    : "📍"
              }}
            </span>
            <div>
              <h3 class="font-bold text-lg text-gray-900 dark:text-white">
                {{ selectedEvent.name }}
              </h3>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                {{ selectedEvent.eventDate | date: "fullDate" : "" : "fr" }}
                @if (actualDuration > 0) {
                  <span> · {{ actualDuration }}h</span>
                }
              </p>
            </div>
          </div>
        </div>
      }
      <!-- KPIs résumé (4 cards comme le fixed) -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-4 text-center">
          <div class="text-2xl font-bold text-blue-600 dark:text-blue-400">
            {{ getTotalPrepared() }}
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">Total préparé</div>
        </div>
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-4 text-center">
          <div class="text-2xl font-bold text-green-600 dark:text-green-400">
            {{ getTotalSold() }}
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Total vendu <span class="text-gray-400">(qte)</span>
          </div>
          @if (getTotalRevenue() > 0) {
            <div class="text-xs font-semibold text-green-500 mt-1">
              &asymp; {{ getTotalRevenue() | number: "1.0-0" }} &euro; CA
            </div>
          }
        </div>
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-4 text-center">
          <div class="text-2xl font-bold text-red-600 dark:text-red-400">
            {{ getTotalWasted() }}
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Total gaspié <span class="text-gray-400">(qte)</span>
          </div>
          <div class="text-xs text-gray-400">({{ getWasteRate() }}%)</div>
          @if (getTotalWasteValue() > 0) {
            <div class="text-xs font-semibold text-red-400 mt-1">
              &asymp; {{ getTotalWasteValue() | number: "1.0-0" }} &euro; perdus
            </div>
          }
        </div>
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-4 text-center">
          <div class="text-2xl font-bold text-orange-600">
            {{ getTotalRuptures() }}
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Ruptures <span class="text-gray-400">(produits)</span>
          </div>
        </div>
      </div>
      <!-- ═══ Score précision IA (NOUVEAU — Phase 4) ═══ -->
      <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6">
        <h3
          class="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"
        >
          <span>🎯</span> Score de précision IA
        </h3>
        <!-- Score global -->
        <div class="flex items-center justify-center gap-6 mb-6">
          <div class="text-center">
            <div
              class="text-5xl font-bold"
              [ngClass]="getAccuracyColor(getAverageAccuracy())"
            >
              {{ getAverageAccuracy() }}%
            </div>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Précision moyenne</p>
          </div>
          <div class="text-center text-sm text-gray-500 dark:text-gray-400">
            <p>{{ getSellThroughRate() }}% vendu</p>
            <p>{{ getWasteRate() }}% gaspillé</p>
          </div>
        </div>
        <!-- Barres par produit -->
        <div class="space-y-2">
          @for (product of productSales; track product) {
            <div class="flex items-center gap-3">
              <span
                class="text-xs text-gray-600 dark:text-gray-400 w-28 truncate text-right"
                [title]="product.productName"
              >
                {{ product.productName }}
              </span>
              <div class="flex-1 h-3 bg-gray-100 dark:bg-slate-800 rounded-full overflow-hidden">
                @if (getProductAccuracy(product) !== null) {
                  <div
                    class="h-full rounded-full transition-all"
                    [ngClass]="getAccuracyBgColor(getProductAccuracy(product)!)"
                    [style.width.%]="getProductAccuracy(product)"
                  ></div>
                }
                @if (getProductAccuracy(product) === null) {
                  <div
                    class="h-full rounded-full bg-gray-300"
                    style="width: 0%"
                  ></div>
                }
              </div>
              <span
                class="text-xs font-bold w-12 text-right"
                [ngClass]="
                  getProductAccuracy(product) !== null
                    ? getAccuracyColor(getProductAccuracy(product)!)
                    : 'text-gray-400'
                "
              >
                {{
                  getProductAccuracy(product) !== null
                    ? getProductAccuracy(product) + "%"
                    : "—"
                }}
              </span>
              <span class="text-xs text-gray-400 w-20">
                {{ product.sold }}/{{ product.recommended || "—" }}
              </span>
            </div>
          }
        </div>
      </div>
      <!-- ═══ Feedback IA (NOUVEAU — Phase 4) ═══ -->
      @if (aiFeedbackMessages.length > 0) {
        <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6">
          <h3
            class="text-lg font-bold text-gray-900 dark:text-white mb-4 flex items-center gap-2"
          >
            <span>🤖</span> Feedback IA
          </h3>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-4">
            Ces données seront utilisées pour améliorer les recommandations
            futures
          </p>
          <div class="space-y-3">
            @for (feedback of aiFeedbackMessages; track feedback) {
              <div
                class="flex items-start gap-3 p-3 rounded-lg border"
                [ngClass]="getFeedbackBg(feedback.type)"
              >
                <span class="text-xl flex-shrink-0">{{ feedback.icon }}</span>
                <p class="text-sm text-gray-800 dark:text-gray-100">{{ feedback.message }}</p>
              </div>
            }
          </div>
        </div>
      }
      <!-- Facteurs exceptionnels -->
      @if (getContextFlagCount() > 0) {
        <div class="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4">
          <h3 class="font-semibold text-sm mb-2">
            ⚠️ Facteurs exceptionnels signalés :
          </h3>
          <div class="flex flex-wrap gap-2">
            @for (flag of getActiveContextFlags(); track flag) {
              <span
                class="px-3 py-1 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 rounded-full text-xs font-medium"
              >
                {{ flag }}
              </span>
            }
          </div>
        </div>
      }
      <!-- Notes -->
      @if (notes) {
        <div class="bg-gray-50 dark:bg-slate-900 rounded-xl p-4">
          <h3 class="font-semibold text-sm text-gray-700 dark:text-gray-300 mb-1">📝 Notes</h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">{{ notes }}</p>
        </div>
      }
      <!-- Boutons -->
      <div class="bg-white dark:bg-slate-800 shadow-sm dark:shadow-slate-900/30 rounded-xl p-6">
        <div class="flex justify-between items-center">
          <button
            (click)="goBack()"
            class="px-5 py-2.5 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900 text-sm font-medium"
          >
            ← Retour
          </button>
          <button
            (click)="submit()"
            [disabled]="loading"
            class="px-8 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed font-semibold transition flex items-center gap-2"
          >
            @if (loading) {
              <span>
                <span
                  class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                ></span>
                Enregistrement...
              </span>
            }
            @if (!loading) {
              <span>✓ Valider et enregistrer</span>
            }
          </button>
        </div>
        <p class="text-xs text-gray-400 text-center mt-3">
          🔒 Vos données alimentent l'apprentissage IA pour de meilleures
          recommandations
        </p>
      </div>
    </div>
  }
</div>
